import { create } from 'zustand';
import type { UserPublic } from '@underline/shared';

interface AuthState {
  user: UserPublic | null;
  setUser: (user: UserPublic | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clear: () => set({ user: null }),
}));
